<template>
    <div>
      <BandhooNav></BandhooNav>
      <Home></Home>
      <SiteFooter></SiteFooter>
    </div>
  </template>
  
  <script>
  import BandhooNav from "@/components/BandhooNav.vue"
import SiteFooter from "@/components/SiteFooter.vue"
import Home from "@/components/Home.vue"
import { aboutUs, appUtils, bandhooClients, bandhooContacts, bandhooStats } from '@/assets/db/static-data'

export default {
  name: 'App',
  data() {
    return {
      aboutUs,
      appUtils,
      bandhooClients,
      bandhooStats,
      bandhooContacts
    }
  },
  methods: {
    sendInformationToGoogleAnalitics(information) {
      console.log("Sending information to google analytics...  " + information);
      this.$gtag.event(information);
      console.log("Information sent to google analytics...");
    }
  },
  created(){
    this.sendInformationToGoogleAnalitics("website_visits")
  },
  components: {
    BandhooNav,
    Home,
    SiteFooter
  }
}
</script>
  
  <style scoped>
  
  </style>

  